import {createFeatureSelector, createSelector} from '@ngrx/store';
import {deliveriesFeatureKey} from './deliveries.reducer';
import {DeliveriesState} from './deliveries.state';

const deliveriesSelector = createFeatureSelector<DeliveriesState>(deliveriesFeatureKey);

export const SELECT_PLANNED_DELIVERIES = createSelector(deliveriesSelector, state => state.plannedDeliveries);
export const SELECT_PLANNED_DELIVERIES_ARE_LOADING = createSelector(deliveriesSelector, state => state.deliveriesAreLoading);
export const SELECT_DELIVERY_CHART_OPTIONS = createSelector(deliveriesSelector, state => state.chartModel.options);
export const SELECT_DELIVERY_CHART_IS_LOADING = createSelector(deliveriesSelector, state => state.chartModel.isLoading);
export const SELECT_DELIVERY_STATUS_ICONS = createSelector(deliveriesSelector, state => state.deliveryStatusIcons);
export const SELECT_VALIDATED_PBOS = createSelector(deliveriesSelector, state => state.validatedPbos);
